<template>
  <div class="m-lazy-render__chunk">
    <template v-if="!chunkIsVisible">
      <div class="m-lazy-render__lazy-dummy-node" />
    </template>
    <template v-else>
      <MCheckbox
        v-for="item in payload"
        :id="`m-checkbox-group-${item[idAttr]}`"
        :key="item[idAttr]"
        class="m-multiselect__choice"
        :value="itemIsActive(item)"
        :is-focus="itemIsFocus(item)"
        :highlight-info="item.highlightInfo"
        :disabled="itemIsDisabled(item)"
        :label-text="itemText(item)"
        @click.native="handleItemClick(item)"
        @handle-click-navigation="$emit('handle-click-navigation', $event)"
      />
    </template>
  </div>
</template>

<script>
  import MCheckbox from 'components/Inputs/Basic/MCheckbox';

  export default {
    name: 'MMultiSelectChoiceOptionGroup',
    components: {MCheckbox},
    props: {
      value: {
        type: Array,
        required: true
      },
      chunkIsVisible: {
        type: Boolean,
        default: false
      },
      idAttr: {
        type: String,
        required: true
      },
      currentFocusItemId: {
        type: [Number, String],
        default: null
      },
      valueSet: {
        type: Set,
        required: true
      },
      displayIdAttr: {
        type: [String, Boolean],
        default: false
      },
      payload: {
        type: Array,
        required: true
      },
      disableOptionPredicate: {
        type: Function,
        default: () => false
      },
      formatFn: {
        type: Function,
        default: undefined
      },
      disableAddItems: {
        type: Boolean,
        default: false
      },
      showId: {
        type: Boolean,
        default: false
      },
      textAttr: {
        type: String,
        required: true
      }
    },
    methods: {
      itemIsDisabled (item) {
        if (this.disableAddItems) {
          this.disableOptionPredicate('', this.value);
          return !this.itemIsActive(item) && this.disableAddItems;
        }
        return this.disableOptionPredicate(item, this.value, this.choices);
      },
      itemIsActive (item) {
        return this.valueSet.has(item[this.idAttr]);
      },
      itemIsFocus (item) {
        return this.currentFocusItemId === item.id;
      },
      itemText (item) {
        // in case if choices not fetched yet
        if (!item) {
          return '';
        }

        if (this.formatFn) {
          return this.formatFn(item);
        }

        if (this.showId) {
          return `№${item[this.displayIdAttr]} ${item[this.textAttr]}`;
        }
        return item[this.textAttr];
      },
      handleItemClick (item) {
        this.$emit('toggleItem', item);
      }
    }
  };
</script>

<style>
  .m-multiselect__choice {
    width: var(--lazy-max-width);
  }
</style>
